import {
    Avatar,
    Breadcrumbs,
    Button,
    type BreadcrumbsProps,
    type Theme
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { imageURL } from "../http";
import { useIsSmall, useWebsite } from "../hooks";
import { ancestors, shortName, type Category } from "../models";

interface CategoryBreadcrumbProps extends BreadcrumbsProps {
    categoryId: number;
    fontSize?: string;
    logoSize?: number;
}

export const CategoryBreadcrumb = ({ categoryId, fontSize, logoSize = 52, children, ...rest }: CategoryBreadcrumbProps): JSX.Element => {
    const { categories } = useWebsite();
    const category: Category | undefined = categories.find(x => x.categoryId === categoryId);
    const filtered = category ? [...ancestors(categories, category), category] : [];
    const [q] = useSearchParams();
    const query = Object.fromEntries(q);
    const isSmall = useIsSmall();
    return <Breadcrumbs
        aria-label="breadcrumb"
        sx={(t: Theme) => ({
            "& .MuiBreadcrumbs-li": { display: "flex" },
            color: contrastText(t),
            flexWrap: "nowrap",
        })}
        {...rest}
    >
        {children}
        {
            filtered.filter((_, i) => !isSmall || i === categories.length - 1).map(c => {
                const name = shortName(c.name);
                return <Button
                    color="primary"
                    autoCapitalize="on"
                    href={`/?${new URLSearchParams({ ...query, category: c.id, }).toString()}`}
                    sx={{ textTransform: "none", fontSize }}
                
                    aria-label={name}
                    startIcon={c.image ? <Avatar variant="rounded" slotProps={{ img: { sx: { objectFit:"contain" } } }} src={c.image ? imageURL(c.image) : undefined} alt={name} sx={{ height: logoSize, width: logoSize, bgcolor: "transparent", paddingRight: 0.5 }}/> : <></>}
                >
                    {name}
                </Button>

            })
        }
    </Breadcrumbs>;
};

export const contrastText = (t: Theme): string => t.palette.getContrastText(t.palette.primary.main);